import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Placed once inside the Router. React Router doesn't reset scroll position
// on navigation by default, so without this, a new page opens wherever you
// happened to be scrolled to on the previous page.
export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}